import { useEffect, useRef, useState } from 'react';

export const useKeepTrue = (value: boolean, graceMs = 250): boolean => {
    const [kept, setKept] = useState(value);
    const timeoutRef = useRef<number | null>(null);
    useEffect(() => {
        if (value) {
            if (timeoutRef.current !== null) {
                window.clearTimeout(timeoutRef?.current!);
                timeoutRef.current = null;
            }
            setKept(true);
            return;
        }
        timeoutRef.current = window.setTimeout(() => {
            timeoutRef.current = null;
            setKept(false);
        }, graceMs);
        return () => {
            if (timeoutRef.current !== null) {
                window.clearTimeout(timeoutRef?.current!);
                timeoutRef.current = null;
            }
        };
    }, [value, graceMs]);
    return kept;
};